import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.search";
import _defineProperty from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from "@/mixins/packageTableMixins";
import addAppCustom from "./components/addAppCustom";
import downloadCustom from "./components/downloadCustom";
import customDetails from "./components/customDetails.vue";
import downloadHistory from "./components/downloadHistory.vue";
import config from "@/config/index";
import passCom from "./components/passCom";
import { get_type } from '@/api/jingxiaoshang';
import { device_distribution_list, get_downloadtoken, allocation_add, allocation_del, export_success_did, get_merchant_all, quxiao_fenpei, did_config_pass } from "@/api/jingxiaoshang";
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data: function data() {
    var _form_filter;

    return {
      formModelGlobe: null,
      formData1: null,
      dataValue: [],
      dataText: null,
      showImg: false,
      showImg1: false,
      showImgUrl: null,
      pass_priv: 1,
      dids: [],
      merchantData: [],
      statusData0: [{
        value: 0,
        name: this.$t("通道0")
      }, {
        value: 1,
        name: this.$t("通道1")
      }],
      statusData: [{
        value: -1,
        name: this.$t("全部")
      }, {
        value: 2,
        name: this.$t("devicelist.online")
      }, {
        value: 1,
        name: this.$t("devicelist.offline")
      }],
      statusData2: [{
        value: -1,
        name: this.$t("全部")
      }, {
        value: 1,
        name: this.$t("已分配")
      }, {
        value: 2,
        name: this.$t("未分配")
      }],
      statusData3: [{
        value: "xciot-prod-cnsz",
        name: this.$t("Changelang.中国")
      }, {
        value: "xciot-prod-hk",
        name: this.$t("Changelang.香港")
      }, {
        value: "xciot-prod-us2",
        name: this.$t("美国")
      }, {
        value: "xciot-prod-eu",
        name: this.$t("Changelang.欧洲")
      }],
      device_typeData: [{
        value: "-1",
        name: "全部"
      }, {
        value: "1",
        name: "家储"
      }, {
        value: "2",
        name: "基站"
      }, {
        value: "3",
        name: "高压"
      }, {
        value: "4",
        name: "PCS"
      }, {
        value: "5",
        name: "其他"
      }],
      form_filter: (_form_filter = {
        project_id: null,
        hw_ver: null,
        sw_ver: null,
        model_code: null,
        sw_channel: 1
      }, _defineProperty(_form_filter, "sw_ver", null), _defineProperty(_form_filter, "status", null), _defineProperty(_form_filter, "fp_status", null), _defineProperty(_form_filter, "po", null), _defineProperty(_form_filter, "sn", null), _defineProperty(_form_filter, "country_code", "xciot-prod-cnsz"), _form_filter),
      //共用的查询与重置
      topButtonList: [{
        name: this.$t("query"),
        type: "primary",
        icon: "ios-search",
        method: this.search
      }, {
        name: this.$t("reset"),
        type: "error",
        icon: "ios-refresh",
        method: this.reset
      }],
      // //共用的右侧添加按钮
      topButtonList1: [{
        name: this.$t("导出产测成功设备id"),
        icon: "ios-cloud-download",
        type: "primary",
        method: this.exportsuccess
      }, // {
      //   name:'导入',
      //   icon:'ios-cloud-upload',
      //   type:'primary',
      //   method:this.add
      // },
      {
        name: this.$t("批量分配"),
        icon: "ios-hand",
        type: "primary",
        method: this.pl_distribution
      }],
      reqBase: {
        page: 1,
        page_size: 15
      },
      status: true,
      //是否企业认证
      tableDataList: [],
      getPageTotal: 0,
      operationButtonList: [// {
      //   name:this.$t('devicelist.exporthistory'),
      //   type:'text',
      //   icon:'',
      //   method:this.export
      // },
      // {
      //   name:this.$t('devicelist.control'),
      //   type:'text',
      //   icon:'',
      //   method:this.control
      // },
      // {
      //   name:this.$t('devicelist.see'),
      //   type:'text',
      //   icon:'',
      //   method:this.details
      // },
      // {
      //   name:this.$t('devicelist.viewtrajectory'),
      //   type:'text',
      //   icon:'',
      //   method:this.trajectory
      // },
      {
        name: this.$t("devicelist.distribution"),
        type: "text",
        icon: "",
        method: this.distribution
      }, {
        name: this.$t("devicelist.canceldistribution"),
        type: "text",
        icon: "",
        method: this.quxiao_distribution
      }],
      // operationButtonList1:[
      //   {
      //     name:this.$t('operationModule.submitReview'),
      //     type:'primary',
      //     icon:'',
      //     method:this.submitReview
      //   },
      // ],
      columnsheader: [],
      columns1: [{
        title: "设备ID",
        key: "did",
        align: "center",
        tree: true
      }, {
        title: "代理商",
        key: "shop_name",
        align: "center",
        tree: true
      }],
      modelCodeList: [] // 产品型号列表

    };
  },
  props: {
    reducehe: {},
    code: {}
  },
  components: {
    customDetails: customDetails
  },
  computed: {
    userInfoStore: function userInfoStore() {
      var data = this.$store.state.user.userInfo;
      return data;
    }
  },
  methods: {
    getType: function () {
      var _getType = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.modelCodeList.splice(0);
                _context.next = 3;
                return get_type({});

              case 3:
                res = _context.sent;

                if (!(res.result === 0)) {
                  _context.next = 10;
                  break;
                }

                this.modelCodeList = res.body.model_codeData || [];

                if (!(this.modelCodeList.length > 0)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", this.modelCodeList[0].model_code);

              case 8:
                _context.next = 11;
                break;

              case 10:
                return _context.abrupt("return", '');

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getType() {
        return _getType.apply(this, arguments);
      }

      return getType;
    }(),
    alarmlog: function alarmlog(row) {
      var routeData = this.$router.push({
        path: "/alarmManage/alermDes",
        query: {
          did: row.did
        }
      });
      window.open(routeData.href, "_self"); // const routeData = this.$router.push({ path: '/deviceman/details', query: { did: row.did }})
      //   window.open(routeData.href, '_self')
    },
    historylog: function historylog(row) {
      var routeData = this.$router.push({
        path: "/deviceman/distributionLog",
        query: {
          did: row.did
        }
      });
      window.open(routeData.href, "_self");
    },
    // mechanHome(row){
    //   window.open(config.webLinkUrl+'/index/'+row.company_code)
    // },
    // pageSizeChange(){
    // },
    getUser: function getUser() {
      return this.$store.state.user.userInfo;
    },
    configpass: function configpass(row) {
      var _this2 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "5px"
            }
          }, _this2.$t("devicelist.passman")), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h("Divider", {
            style: {
              margin: "8px 0"
            }
          }), h(passCom, {
            ref: "passCom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              parent_code: "0",
              parent_name: "无",
              setData: row
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.passCom;
          obj.checkForm().then(function (res) {
            // console.log("req", {...obj.formModel})
            // return;
            if (res) {
              did_config_pass(_objectSpread({}, obj.formModel)).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg = res.errorMsg;
                  vm.$Message.success(_msg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    //导出产测成功设备
    exportsuccess: function exportsuccess(row) {
      var _this3 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 600,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "15px"
            }
          }, _this3.$t("导出产测成功设备")), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h(downloadCustom, {
            ref: "downloadCustom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              projectCode: _this3.code,
              dids: _this3.dids
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.downloadCustom;
          obj.checkForm().then(function (req) {
            if (req) {
              var formModel = obj.formModel; //提交请求

              var domain = vm.get_domain();
              get_downloadtoken().then(function (res) {
                // console.log(res.result)
                //     return
                _this.buttonLoading = false;

                if (res.result === 0) {
                  var downloadtoken = res.body.downloadtoken;
                  var params = "?type=1&model_code=" + formModel.model_code + "&start_time=" + formModel.start_time + "&end_time=" + formModel.end_time + "&downloadtoken=" + downloadtoken;
                  window.open(domain + "/index.php/admin/devicedetail/export_success_did" + params);

                  _this.$Modal.remove();
                } else {
                  _this.$Message.error(res.errorMsg);
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },

    /**
     * 导入sn
     */
    exportsuccess2: function exportsuccess2() {
      var _this4 = this;

      var vm = this;
      var model_code_list = vm.getModelCode;
      var config = {
        loading: true,
        width: 600,
        render: function render(h) {
          return h("div", [h("h3", _this4.$t("common.importsn")), h(uploadsnCom, {
            ref: "uploadsnCom",
            props: {
              edit: false,
              _vm: vm,
              model_code_list: model_code_list,
              model_code: _this4.form_filter.model_code
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.uploadsnCom;
          obj.checkForm().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              var formData = new FormData();
              formData.append("filename", formModel.filename);
              formData.append("model_code", formModel.model_code);
              import_sn(formData).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success({
                    content: res.errorMsg,
                    duration: 10,
                    closable: true
                  });
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg, 5);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    //导出历史数据记录
    // export(row) {
    //   let vm = this
    //   let config = {
    //     title: "导出",
    //     loading: true,
    //     content: "您确定要导出当前数据吗？",
    //     onOk: function () {
    //       let _this = this
    //         get_downloadtoken().then(res => {
    //            _this.buttonLoading = false
    //            if (res.result === 0) {
    //             let downloadtoken = res.body.downloadtoken
    //             let params =
    //               "?type=1&downloadtoken=" +
    //                downloadtoken +"&did="+row.did
    //             window.open("http://pcphp.test.xcthings.com/index.php/admin/device/history_daochu" + params)
    //             vm.$Modal.remove()
    //           } else {
    //             vm.$Message.error(res.errorMsg)
    //           }
    //         })
    //     }
    //   }
    //   this.$Modal.confirm(config)
    // },
    export: function _export(row) {
      var _this5 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 600,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "15px"
            }
          }, _this5.$t("dictmenu.suredelete")), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h(downloadHistory, {
            ref: "downloadHistory",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              projectCode: _this5.code,
              dids: _this5.dids
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.downloadHistory;
          obj.checkForm().then(function (req) {
            if (req) {
              var formModel = obj.formModel;
              var domain = vm.get_domain(); //提交请求
              // console.log("formModel",formModel)
              // return;

              get_downloadtoken().then(function (res) {
                _this.buttonLoading = false;

                if (res.result === 0) {
                  var downloadtoken = res.body.downloadtoken;
                  var params = "?type=1&downloadtoken=" + downloadtoken + "&did=" + row.did + "&time_start=" + formModel.start_time + "&time_end=" + formModel.end_time;
                  window.open(domain + "/index.php/admin/device/history_daochu" + params);
                  vm.$Modal.remove();
                } else {
                  vm.$Message.error(res.errorMsg);
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    get_domain: function get_domain() {
      var result = "";

      if (process.env.NODE_ENV === "development") {
        result = config.baseUrl.dev;
      } else if (process.env.VUE_APP_BUILD === "production") {
        result = config.baseUrl.pro;
      } else {
        result = config.baseUrl.alp;
      }

      return result;
    },
    pl_distribution: function pl_distribution(row) {
      var _this6 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 600,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "15px"
            }
          }, _this6.$t("devicelist.mostfenpei")), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h(addAppCustom, {
            ref: "addAppCustom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              projectCode: _this6.code,
              dids: _this6.dids
            }
          })]);
        },
        onOk: function onOk() {
          var _this7 = this;

          var _this = this;

          var obj = this.$refs.addAppCustom;
          obj.checkForm().then(function (req) {
            if (req) {
              //提交请求
              debugger;
              var formModel = obj.formModel; //formData.append('filename',formModel.filename)

              var formData = new FormData();
              vm.formModelGlobe = formModel; //formData['filename'] = formModel.filename
              //formData['merchant_code'] = formModel.merchant_code
              //formData['dids']=formModel.dids
              //return;
              //formData=formModel

              formData.append("filename", formModel.filename);

              for (var i = 0; i < formModel.merchant_code.length; i++) {
                formData.append("merchant_code[" + i + "]", formModel.merchant_code[i]);
              }

              for (var i = 0; i < formModel.dids.length; i++) {
                formData.set("dids[" + i + "]", formModel.dids[i]);
              }

              allocation_add(formData).then(function (res) {
                console.log("WOJIsadas0", formData);

                if (res.result === 0) {
                  vm.$Message.success(res.errorMsg);
                  vm.$Modal.remove();
                  _this7.dids = [];
                  vm.init();
                } else {
                  if (res.result === 300) {
                    vm.$Modal.remove();
                    console.log("WOJIsadas1", formData.get("filename")); // let formData = new FormData();
                    // formData.append("filename", formModel.filename);
                    // formData.append("model_code", formModel.model_code);

                    vm.formData1 = formData.get("filename");
                    vm.dataValue = res.body;
                    vm.dataText = res.errorMsg;
                    vm.showImg1 = true; //  _this.buttonLoading = false;
                    // vm.$Modal.remove();
                    //   vm.$Modal.info({
                    //     title: "提示",
                    //     content: `<div>
                    //   <p>错误信息: ${dataText}</p>
                    //   <p>详细数据: ${JSON.stringify(dataValue)}</p>
                    // </div>`,
                    //     onOk() {
                    //       // 用户点击确定后的逻辑
                    //     },
                    //     zIndex: 9999,
                    //   });
                  }

                  vm.$Message.error(res.errorMsg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    okData: function okData() {
      var vm = this;
      console.log("WOJIsadas");
      var fd = new FormData();
      fd.append("is_confirm", 1);
      console.log("formModelGlobe", this.formModelGlobe);
      fd.append("filename", this.formModelGlobe.filename);

      for (var i = 0; i < this.formModelGlobe.merchant_code.length; i++) {
        fd.append("merchant_code[" + i + "]", this.formModelGlobe.merchant_code[i]);
      }

      for (var i = 0; i < this.formModelGlobe.dids.length; i++) {
        fd.append("dids[" + i + "]", this.formModelGlobe.dids[i]);
      }

      fd.append("is_confirm", 1); // this.formData1.is_confirm = 1;
      // vm.formData1.append('allocation_add',1)
      // debugger;

      allocation_add(fd).then(function (res) {
        console.log("WOJIsadas222", res, vm.formData1);

        if (res.result === 0) {
          vm.$Message.success(vm.$t("importResult"));
        } else {
          vm.$Message.success(res.errorMsg);
        }

        vm.$Modal.remove();
        vm.showImg1 = false;
      });
    },
    didSelectChange: function didSelectChange(SelectItem) {
      this.dids.splice(0);

      if (SelectItem && SelectItem.length > 0) {
        for (var i in SelectItem) {
          var list = SelectItem[i];
          this.dids.push(list.did); // this.ids = list.id
        }
      }

      console.log(this.dids);
    },
    quxiao_distribution: function quxiao_distribution(row) {
      var vm = this;
      var config = {
        loading: true,
        title: this.$t("devicelist.cancelfenpei"),
        content: this.$t("devicelist.quedingcancel") + row.did,
        onOk: function onOk() {
          var _this = this;

          quxiao_fenpei({
            id: row.id
          }).then(function (res) {
            if (res.result === 0) {
              vm.$Message.success(res.errorMsg);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(res.errorMsg);
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    distribution: function distribution(row) {
      var _this8 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 800,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "15px"
            }
          }, row.did + _this8.$t("devicelist.fenpei")), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h(addAppCustom, {
            ref: "addAppCustom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              projectCode: _this8.code,
              setData: row
            }
          })]);
        },
        onOk: function onOk() {
          var _this9 = this;

          debugger;
          var obj = this.$refs.addAppCustom;
          obj.checkForm().then(function (req) {
            if (req) {
              //提交请求
              var formModelVal = obj.formModel;
              allocation_add(_objectSpread({}, formModelVal)).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(res.errorMsg);
                  vm.$Modal.remove();
                  _this9.dids = [];
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg);
                  _this9.buttonLoading = false;
                }
              });
            } else {
              _this9.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    init: function init() {
      var _this10 = this;

      localStorage.setItem('country_code', this.form_filter.country_code);
      var userinfo = this.getUser();
      this.pass_priv = userinfo.pass_priv;
      this.getMerchantData();
      this.tableLoading = true;
      device_distribution_list(_objectSpread({}, this.reqBase)).then(function (res) {
        _this10.tableLoading = false;
        _this10.tableDataList = [];

        if (res.result === 0) {
          _this10.tableDataList = res.body.list || [];
          console.log("this.tableDataList", _this10.tableDataList);
          _this10.getPageTotal = res.body.total;
        } else {
          _this10.tableDataList = [];
          _this10.getPageTotal = 0;

          _this10.$Message.error(res.errorMsg);
        }
      });
    },
    //新增
    // add() {
    //   let vm = this;
    //   let config = {
    //     loading: true,
    //     width: 800,
    //     render: (h) => {
    //       return h('div', [
    //         h('div', { style: { display: 'flex', justifyContent: 'space-between' } }, [
    //           h('h3', { style: { width: '100%', paddingBottom: '5px' } }, '添加'),
    //           h('icon', {
    //             props: { type: 'md-close', size: '16' },
    //             style: {
    //               cursor: 'pointer'
    //             },
    //             on: {
    //               'click': evt => {
    //                 vm.$Modal.remove()
    //               }
    //             }
    //           })
    //         ]),
    //         h('Divider',{
    //           style:{
    //             margin:'8px 0'
    //           }
    //         }),
    //         h(addAppCustom, {
    //           ref: 'addAppCustom',
    //           props: {
    //             _vm: vm,
    //             $store:vm.$store,
    //             edit:false,
    //             projectCode:this.code
    //           }
    //         })
    //       ])
    //     },
    //     onOk: function () {
    //       let _this = this;
    //       let obj = this.$refs.addAppCustom;
    //       obj.checkForm().then(res => {
    //         if (res) {
    //           //提交请求
    //           let formModel = obj.formModel;
    //           building_add(formModel).then(res => {
    //             let msg=res.errorMsg;
    //             if (res.result === 0) {
    //               let msg=res.errorMsg;
    //               vm.$Message.success(msg);
    //               vm.$Modal.remove();
    //               vm.init();
    //             } else {
    //               vm.$Message.error(msg);
    //               _this.buttonLoading = false;
    //             }
    //           });
    //         } else {
    //           _this.buttonLoading = false;
    //         }
    //       });
    //     }
    //   };
    //   this.$Modal.confirm(config);
    // },
    getMerchantData: function getMerchantData() {
      var _this11 = this;

      console.log(111);
      this.merchantData.splice(0);
      get_merchant_all().then(function (res) {
        if (res.result === 0) {
          console.log(data);
          var data = res.body;

          _this11.checkTree(data); // console.log('a',data)


          _this11.merchantData = data;
        }
      });
    },
    checkTree: function checkTree(arr) {
      for (var i in arr) {
        if (arr[i].shop_name) {
          arr[i].value = arr[i].merchant_code;
          arr[i].label = arr[i].shop_name;
          arr[i].title = arr[i].shop_name;
        } else if (arr[i].shop_name) {
          arr[i].title = arr[i].shop_name;
        }

        if (arr[i].children_shop && arr[i].children_shop.length > 0) {
          var _arr$i$children;

          (_arr$i$children = arr[i].children).push.apply(_arr$i$children, _toConsumableArray(arr[i].children_shop));
        }

        if (arr[i].children && arr[i].children.length > 0) {
          this.checkTree(arr[i].children);
        }
      }
    },
    search: function search() {
      this.onSearch(this.form_filter);
    },
    reset: function () {
      var _reset = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _this$form_filter;

        var model_code;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.form_filter = (_this$form_filter = {
                  model_code: "",
                  sw_ver: "",
                  merchant_code: [],
                  fp_status: -1,
                  did: "",
                  status: -1,
                  project_id: null,
                  hw_ver: null
                }, _defineProperty(_this$form_filter, "sw_ver", null), _defineProperty(_this$form_filter, "sw_channel", 1), _defineProperty(_this$form_filter, "bms_sn", null), _defineProperty(_this$form_filter, "pack_sn", null), _defineProperty(_this$form_filter, "country_code", "xciot-prod-cnsz"), _this$form_filter);
                _context2.next = 3;
                return this.getType();

              case 3:
                model_code = _context2.sent;

                if (model_code) {
                  this.$set(this.form_filter, "model_code", model_code);
                  this.$set(this.reqBase, "model_code", model_code);
                }

                this.search();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }(),
    control: function control(row) {
      var routeData = this.$router.push({
        path: "/deviceman/control",
        query: {
          did: row.did
        }
      });
      window.open(routeData.href, "_self");
    },
    details: function details(row) {
      console.log("rowrowrowrow", row.class_codes);

      if (row.class_codes.includes("SCLI")) {
        console.log("rowrowrowrow", 1);
        var routeData = this.$router.push({
          path: "/deviceman/detailsSCLI",
          query: {
            did: row.did
          }
        });
        window.open(routeData.href, "_self");
      } else {
        console.log("rowrowrowrow", 2);

        if (row.model_code == "GBMSMT") {
          var _routeData = this.$router.push({
            // path: "/deviceman/detailsNew",detailsNbc,detailsSCLI
            path: "/deviceman/detailsNew",
            query: {
              did: row.did
            }
          });

          window.open(_routeData.href, "_self");
        } else {
          if (row.device_type == 1) {
            var _routeData2 = this.$router.push({
              path: "/deviceman/details",
              query: {
                did: row.did
              }
            });

            window.open(_routeData2.href, "_self");
          } else if (row.device_type == 2) {
            // localStorage.setItem('rowData', JSON.stringify(row));
            var _routeData3 = this.$router.push({
              path: "/deviceman/detailsdy",
              query: {
                did: row.did
              }
            });

            window.open(_routeData3.href, "_self");
          } else if (row.device_type == 3) {
            var _routeData4 = this.$router.push({
              path: "/deviceman/detailscc",
              query: {
                did: row.did
              }
            });

            window.open(_routeData4.href, "_self");
          }
        }
      }
    },
    trajectory: function trajectory(row) {
      var routeData = this.$router.push({
        path: "/trajectory",
        query: {
          did: row.did
        }
      });
      window.open(routeData.href, "_self");
    },
    // details(row){
    //   let vm = this;
    //   let config = {
    //     loading: true,
    //     width: 800,
    //     okText:'关闭',
    //     render: (h) => {
    //       return h('div', [
    //         h('div', { style: { display: 'flex', justifyContent: 'space-between' } }, [
    //           h('h3', { style: { width: '100%', paddingBottom: '15px' } }, '详情'),
    //           h('icon', {
    //             props: { type: 'md-close', size: '16' },
    //             style: {
    //               cursor: 'pointer'
    //             },
    //             on: {
    //               'click': evt => {
    //                 vm.$Modal.remove()
    //               }
    //             }
    //           })
    //         ]),
    //         h(customDetails, {
    //           ref: 'customDetails',
    //           props: {
    //             _vm: vm,
    //             $store:vm.$store,
    //             edit:true,
    //             setData: row
    //           }
    //         })
    //       ])
    //     },
    //     onOk: function () {
    //       vm.$Modal.remove();
    //     }
    //   };
    //   this.$Modal.success(config);
    // },
    edit: function edit(row) {
      var _this12 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 800,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "15px"
            }
          }, "分配经销商"), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h(addAppCustom, {
            ref: "addAppCustom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              projectCode: _this12.code,
              setData: row
            }
          })]);
        },
        onOk: function onOk() {
          var _this13 = this;

          var _this = this;

          var obj = this.$refs.addAppCustom;
          obj.checkForm().then(function (req) {
            if (req) {
              //提交请求
              var formModel = obj.formModel;
              allocation_add(_objectSpread({}, formModel)).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(res.errorMsg);
                  vm.$Modal.remove();
                  _this13.dids = [];
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    del: function del(row) {
      var vm = this;
      var config = {
        loading: true,
        title: "删除",
        content: "您确定要删除序号为 " + row.id + " 的数据吗",
        onOk: function onOk() {
          var _this = this;

          allocation_del({
            allocation_code: row.allocation_code
          }).then(function (res) {
            if (res.result === 0) {
              vm.$Message.success(res.errorMsg);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(res.errorMsg);
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3() {
      var query, model_code;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              query = this.$route.query;

              if (query && query.hasOwnProperty("status")) {
                this.$set(this.form_filter, "status", parseInt(query.status));
              }

              _context3.next = 4;
              return this.getType();

            case 4:
              model_code = _context3.sent;
              debugger;

              if (model_code) {
                this.$set(this.form_filter, "model_code", model_code);
                this.$set(this.reqBase, "model_code", model_code);
              }

              if (this.code) {
                this.$set(this.reqBase, "project_code", this.code);
              }

              if (this.reducehe) {
                this.reduceheight = this.reducehe;
              } else {
                this.search();
              } // this.$set(this,'columnsheader',baseColumns)


              console.log("this.columnsheader", this.columnsheader.length);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  created: function created() {
    var _this14 = this;

    this.columnsheader = [// {
    //   align: "center",
    //   title: "序号",
    //   width: 60,
    //   key: "did",
    //   type: "selection",
    //   // _disabled:true
    // },
    {
      align: "center",
      title: this.$t("productImg"),
      width: 100,
      key: "pic",
      render: function render(h, _ref) {
        var row = _ref.row;
        return h("div", {
          on: {
            click: function click() {
              _this14.showImgUrl = row.pic;
              _this14.showImg = true;
            }
          }
        }, [h("Avatar", {
          style: {
            cursor: "pointer"
          },
          props: {
            src: row.pic
          }
        })]);
      }
    }, {
      align: "center",
      title: this.$t("devicelist.modelcode"),
      minWidth: 120,
      key: "model_code"
    }, {
      align: "center",
      title: this.$t("devicelist.did"),
      minWidth: 120,
      width: 250,
      key: "did",
      render: function render(h, _ref2) {
        var row = _ref2.row;
        return h("span", {
          style: {
            color: "#2d8cf0",
            "text-decoration": "underline",
            cursor: "pointer"
          },
          on: {
            click: function click() {
              _this14.details(row);
            }
          }
        }, row.did);
      }
    }, {
      align: "center",
      title: this.$t("devicelist.status"),
      minWidth: 120,
      key: "status",
      render: function render(h, _ref3) {
        var row = _ref3.row;
        var result = "";
        var color = "";

        if (row.status === 1) {
          color = "error";
          result = _this14.$t("devicelist.offline");
        } else if (row.status === 2) {
          color = "success";
          result = _this14.$t("devicelist.online");
        } else {
          color = "primary";
          result = _this14.$t("devicelist.notknow");
        }

        return h("Tag", {
          props: {
            color: color
          }
        }, result);
      }
    }, {
      align: "center",
      title: "SN",
      minWidth: 120,
      key: "sn"
    }, {
      align: "center",
      title: this.$t("devicelist.projectnum"),
      minWidth: 120,
      key: "project_id"
    }, {
      align: "center",
      title: this.$t("devicelist.hardwareversionnumber"),
      minWidth: 120,
      key: "hw_ver"
    }, {
      align: "center",
      title: this.$t("devicelist.softwareversionnumber"),
      minWidth: 100,
      key: "sw_ver"
    }, {
      align: "center",
      title: this.$t("devicelist.agent"),
      minWidth: 120,
      key: "shop_name"
    }, {
      align: "center",
      title: this.$t("devicelist.lastonlinetime"),
      minWidth: 120,
      key: "last_online_time"
    }, {
      align: "center",
      title: "bms_sn",
      minWidth: 120,
      key: "bms_sn"
    }, {
      align: "center",
      title: "pack_sn",
      minWidth: 120,
      key: "pack_sn"
    }, {
      align: "center",
      title: this.$t("devicelist.activationtime"),
      minWidth: 120,
      key: "activation_time"
    }, {
      align: "center",
      title: this.$t("operation"),
      minWidth: 120,
      fixed: "right",
      key: "Operating",
      render: function render(h, _ref4) {
        var row = _ref4.row;

        if (1) {
          var arr = [];

          for (var i in _this14.operationButtonList) {
            if (row.fp_did == "" && i == 0) {
              (function () {
                //去分配
                var list = _this14.operationButtonList[i];
                arr.push(h("Button", {
                  style: {
                    marginLeft: "5px",
                    marginBottom: "3px",
                    color: "#2d8cf0"
                  },
                  props: {
                    type: list.type,
                    size: list.size ? list.size : "small"
                  },
                  on: {
                    click: function click() {
                      list.method(row);
                    }
                  }
                }, list.name));
              })();
            } else {
              if (row.fp_did != "" && i == 1) {
                (function () {
                  //取消分配
                  var list = _this14.operationButtonList[i];
                  arr.push(h("Button", {
                    style: {
                      marginLeft: "5px",
                      marginBottom: "3px",
                      color: "#2d8cf0"
                    },
                    props: {
                      type: list.type,
                      size: list.size ? list.size : "small"
                    },
                    on: {
                      click: function click() {
                        list.method(row);
                      }
                    }
                  }, list.name));
                })();
              }
            }
          }

          return h("div", arr);
        }
      }
    }]; // 沛城平台账号 产测时间和产测状态

    if (localStorage.getItem("is_dingji") == 1) {
      this.columnsheader.push({
        align: "center",
        title: this.$t("devicelist.cctime"),
        minWidth: 120,
        key: "cctime"
      }, {
        align: "center",
        title: this.$t("devicelist.ccstatus"),
        minWidth: 120,
        key: "ccstatus"
      });
    }
  }
};